import EventEmitter from 'events';
import dispatcher from '../../dispatchers/dispatcher';

class Store extends EventEmitter {
    
        constructor() {
            super()
        }
    
        handleActions(actions) {
            switch (actions.type) {

                // 基础配置 
                case '_scanPolling': this._scanPolling(actions.data); break;
                case '_passwordLogin': this._passwordLogin(actions.data); break;
            }
        }

        /**
         * 基础配置
         */
        _scanPolling(data) {
            this.scanPolling = data;
            this.emit('_scanPolling');
        }
        _returnScanPolling() {
            return this.scanPolling || [];
        }

        /**
         * 账号密码登录
         */
        _passwordLogin(data) {
            this.passwordLogin = data;
            this.emit('_passwordLogin');
        }
        _returnPasswordLogin() {
            return this.passwordLogin || {};
        }

    }
    
    const store = new Store();
    dispatcher.register(store.handleActions.bind(store));
    
    export default store;


// WEBPACK FOOTER //
// ./src/applications/stores/store.js